import React, { useEffect } from "react";
import { useOptimizerNavigation } from "./useOptimizerNavigation";
import RuvnlOptimizerDas from "./OptimizerDas";

import RuvnlSimulationIndex from "./SimulationOptimizer/SimulationIndex";
import RuvnlSimulationOptimization from "./SimulationOptimizer/OptimizationIndex";
import { getGNAOptimizerSession } from "../../../Rest_api/RestApi";
import { setOptimizerGridcoDateRange } from "../../../store/state/GNAOptimizer/GridcoOptimizer/OptimizerDate";
import { setOptimizerGridcoSession } from "../../../store/state/GNAOptimizer/GridcoOptimizer/OptimizerSession";
import { setOptimizerGridcoSessionToken } from "../../../store/state/GNAOptimizer/GridcoOptimizer/OptimizerSessionToken";
import { useDispatch } from "react-redux";

const OptimizerRouter: React.FC = () => {
  const { currentPage } = useOptimizerNavigation();
  const dispatch = useDispatch();

  useEffect(() => {
    async function OptimizerGridcoSession() {
      const data = await getGNAOptimizerSession();
      if (data) {
        dispatch(
          setOptimizerGridcoDateRange({
            startDate: data.start_date,
            endDate: data.end_date,
          })
        );
        dispatch(setOptimizerGridcoSession(data.session));
        dispatch(setOptimizerGridcoSessionToken(data.session_token));
      }
    }
    localStorage.removeItem("OptimizerTab");
    OptimizerGridcoSession();
  }, [dispatch]);
  // Render the appropriate component based on the current page
  const renderPage = () => {
    switch (currentPage) {
      case "generation":
        return <RuvnlSimulationIndex />;
      case "optimisation":
        return <RuvnlSimulationOptimization />;
      default:
        return <RuvnlOptimizerDas />;
    }
  };

  return <>{renderPage()}</>;
};

export default OptimizerRouter;
